module.exports = __webpack_public_path__ + "img/icon-hamburger-blueberry.dd2bbc00.svg";